
import React, { useEffect, useState } from "react";
import GetAppIcon from "@material-ui/icons/GetApp";

const MFAButtonLogic = (props) => {
  const { type, icon, mode = "normal", isSubmit } = props;

  const [values, setValues] = useState({
    ...props,
    buttonClass: "buttonWhiteBlue", 
    buttonType: mode === "form" 
      ? (isSubmit ? "submit" : "button") 
      : "button", 
    endIcon: icon ? <GetAppIcon /> : null,
    href: icon ? "https://egreen.com/pdf/eGreen_white_paper.pdf" : null,
    target: icon ? "_blank" : null,
  });

  const typeToClass = {
    whiteblue: "buttonWhiteBlue",
    whitegreen: "buttonWhiteGreen",
    whiteborderblue: "buttonWhiteBorderBlue",
    backgroundgreen: "buttonBackgroundGreen",
    backgroundwhite: "buttonBackgroundWhite",
    blue: "buttonBlue",
    greenwhite: "buttonGreenWhite",
    bluewhite: "buttonBlueWhite",
    carbonfootprint: "buttonCarbonFootprint",
    buttontransparent: "buttonTransparent",
    buttonPay: "buttonPay",
    buttonGreen: "buttonGreen",
    buttonGreenLarge: "buttonGreenLarge",
    blueLarge: "buttonBlueLarge",
    buttonAutoTransparent: "buttonBackgroundGreenTransparent",
    backgroundSoftGreen: "buttonBackgroundSoftGreen",
    buttonBarnerMain: "buttonBarnerMain",
    backgroundTurquoise: "buttonBackgroundTurquoise",
    backgroundMintGreen: "buttonBackgroundMintGreen",
    greenBlueFont: "buttonGreenBlueFont",
    greenMint: "buttonBackgroundGreenMint",
    defaultGreenMint: "buttonDefaultGreenMint",
    DisabledWhiteborderblue: "buttonwhiteborderblueDisabled",
  };
 
    useEffect(() => {
    setValues((prev) => ({
      ...prev,
      buttonClass: typeToClass[type] || "buttonWhiteBlue",
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  return { values };
};

export default MFAButtonLogic;
